import { NextResponse } from 'next/server';
import type { NextRequest } from 'next/server';

export function middleware(request: NextRequest) {
  // Check if user is accessing the viewer page
  if (request.nextUrl.pathname.startsWith('/viewer')) {
    // Check for authentication cookie
    const authToken = request.cookies.get('auth-token');

    if (!authToken) {
      // Redirect to login if not authenticated
      return NextResponse.redirect(new URL('/login', request.url));
    }
  }

  // Allow the request to proceed
  return NextResponse.next();
}

export const config = {
  matcher: ['/viewer/:path*'],
};
